import React, { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import projects from "../data/projects";
import "../assets/styles/ProjectDetail.scss";

function ProjectDetail() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const project = projects.find((p) => p.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [slug]);

  if (!project) {
    return (
      <div className="project-not-found">
        <p>Project not found.</p>
        <button onClick={() => navigate("/")}>← Back to home</button>
      </div>
    );
  }

  return (
    <div className="project-detail">
      <div className="project-detail-header">
        <button className="back-button" onClick={() => location.key === "default" ? navigate("/") : navigate(-1)}>
          <ArrowBackIcon />
          <span>Back</span>
        </button>
        <div className="project-detail-meta">
          <span className="project-detail-category">{project.category}</span>
          <h1 className="project-detail-title">{project.title}</h1>
        </div>
        <div className="project-detail-chips">
          {project.technologies.map((tech, i) => (
            <Chip
              key={i}
              label={tech}
              size="small"
              className="detail-chip"
              variant="outlined"
            />
          ))}
        </div>
      </div>

      <div className="project-detail-body">
        {project.diagrams ? (
          project.diagrams.map((d, i) => (
            <div className="project-detail-diagram-wrap" key={i}>
              <img
                src={d.src}
                alt={d.label}
                className="project-detail-diagram"
              />
              <span className="project-detail-diagram-label">{d.label}</span>
            </div>
          ))
        ) : project.diagram ? (
          <div className="project-detail-diagram-wrap">
            <img
              src={project.diagram}
              alt={`${project.title} architecture diagram`}
              className="project-detail-diagram"
            />
            <span className="project-detail-diagram-label">Architecture Diagram</span>
          </div>
        ) : null}

        <div className="project-detail-content">
          <div className="project-detail-section">
            <h2>Overview</h2>
            <p>{project.description}</p>
          </div>

          <div className="project-detail-section">
            <h2>Key Outcomes</h2>
            <ul className="project-detail-highlights">
              {project.highlights.map((highlight, i) => (
                <li key={i}>
                  <CheckCircleOutlineIcon className="detail-highlight-icon" />
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectDetail;
